import React, { lazy } from 'react';
import { MapPin } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Location() {
  return <section className="py-16 bg-brand-darker relative border-t border-white/5" data-id="element-79">
      <div className="container mx-auto px-4 md:px-6" data-id="element-80">
        <FadeIn className="text-center mb-8" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-82">
            Nuestra <span className="text-brand-red" data-id="element-83">Ubicación</span>
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-8" data-id="element-84"></div>

          <div className="flex items-center justify-center gap-3 text-brand-silver text-xl" data-id="element-85">
            <MapPin className="text-brand-red w-6 h-6" data-id="element-86" />
            <p data-id="element-87">
              Estamos ubicados en{' '}
              <strong className="text-white" data-id="element-88">Hurlingham</strong>, Provincia de
              Buenos Aires.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-5xl mx-auto" data-id="element-89">
          <div className="relative w-full h-[450px] rounded-sm overflow-hidden border-2 border-white/5 group" data-id="element-90">
            <div className="absolute inset-0 bg-brand-red/5 group-hover:bg-transparent transition-colors duration-500 pointer-events-none z-10" data-id="element-91"></div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d52563.43846618585!2d-58.68110255!3d-34.587396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb966b4b4b4b5%3A0x4b4b4b4b4b4b4b4b!2sHurlingham%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1620000000000!5m2!1ses!2sar" width="100%" height="100%" style={{
            border: 0,
            filter: 'grayscale(1) contrast(1.2) opacity(0.8)'
          }} allowFullScreen loading="lazy" className="group-hover:filter-none transition-all duration-700" data-id="element-92"></iframe>
          </div>
        </FadeIn>
      </div>
    </section>;
}